const accountStorageKey = 'guildguardian-discord-account'
const accountChangedEvent = 'guildguardian-discord-account-changed'
const discordOAuthClientId = '1207976331577663519'
const discordOAuthScope = 'identify'
const discordAuthApiUrl = 'https://api.guildguardian.de/v2/auth'
const teamApplicationApiUrl = 'https://api.guildguardian.de/v2/team'

async function readResponseBody(response) {
  const contentType = response.headers.get('content-type') || ''

  if (contentType.includes('application/json')) {
    return response.json()
  }

  return {}
}

function getApiErrorMessage(data, fallback) {
  return typeof data?.error === 'string' && data.error.trim() ? data.error : fallback
}

function notifyAccountChanged(account) {
  window.dispatchEvent(new CustomEvent(accountChangedEvent, { detail: account }))
}

export function getCurrentDiscordRedirectUri() {
  return `${window.location.origin}${window.location.pathname}`
}

export function getConnectedDiscordAccount() {
  const storedAccount = window.localStorage.getItem(accountStorageKey)

  return storedAccount ? JSON.parse(storedAccount) : null
}

export function getDiscordOAuthUrl(redirectUri = getCurrentDiscordRedirectUri()) {
  const params = new URLSearchParams({
    client_id: discordOAuthClientId,
    response_type: 'code',
    redirect_uri: redirectUri,
    scope: discordOAuthScope
  })

  return `https://discord.com/oauth2/authorize?${params.toString()}`
}

export function getDiscordOAuthResult() {
  const params = new URLSearchParams(window.location.search)
  const code = params.get('code')

  if (!code) {
    return null
  }

  return {
    connected: true,
    provider: 'discord',
    code,
    scope: params.get('scope') || discordOAuthScope,
    receivedAt: new Date().toISOString()
  }
}

export async function exchangeDiscordOAuthCode(code, redirectUri = getCurrentDiscordRedirectUri()) {
  const response = await fetch(discordAuthApiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      token: code,
      redirectUri
    })
  })

  const data = await readResponseBody(response)

  if (!response.ok) {
    throw new Error(getApiErrorMessage(data, `Discord auth failed with status ${response.status}`))
  }

  const account = {
    avatar: data.avatar || '',
    name: data.name || '',
    access: data.access || '',
    provider: 'discord',
    authSource: 'api',
    authenticatedAt: new Date().toISOString()
  }

  window.localStorage.setItem(accountStorageKey, JSON.stringify(account))
  notifyAccountChanged(account)

  return account
}

export function connectDiscordAccount() {
  // Backend-ready mock: replace this with a Discord OAuth redirect once the API exists.
  const accountId = `local-${Date.now()}`
  const account = {
    id: accountId,
    userId: accountId.replace('local-', 'GG-'),
    username: 'Discord Nutzer',
    handle: '@discordnutzer',
    avatarUrl: 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 96 96%22%3E%3Cdefs%3E%3ClinearGradient id=%22g%22 x1=%220%22 x2=%221%22 y1=%220%22 y2=%221%22%3E%3Cstop stop-color=%22%2324dce8%22/%3E%3Cstop offset=%221%22 stop-color=%22%237464ff%22/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width=%2296%22 height=%2296%22 rx=%2228%22 fill=%22url(%23g)%22/%3E%3Ccircle cx=%2234%22 cy=%2238%22 r=%227%22 fill=%22%23060910%22/%3E%3Ccircle cx=%2262%22 cy=%2238%22 r=%227%22 fill=%22%23060910%22/%3E%3Cpath d=%22M31 61c9 8 25 8 34 0%22 fill=%22none%22 stroke=%22%23060910%22 stroke-width=%227%22 stroke-linecap=%22round%22/%3E%3C/svg%3E',
    connectedAt: new Date().toISOString()
  }

  window.localStorage.setItem(accountStorageKey, JSON.stringify(account))
  notifyAccountChanged(account)

  return account
}

export function disconnectDiscordAccount() {
  window.localStorage.removeItem(accountStorageKey)
  notifyAccountChanged(null)
}

export async function submitApplication(application, accessToken) {
  const response = await fetch(teamApplicationApiUrl, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(application)
  })

  const data = await readResponseBody(response)

  if (!response.ok) {
    throw new Error(getApiErrorMessage(data, `Team application failed with status ${response.status}`))
  }

  return data
}
